/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.directive.posTile',
  'acme.view.application.pos.list.modal.controllers',
  'acme.common.service.userPreferences'
])
.controller('PosListController', ['$scope', '$state', '$timeout', '$uibModal', '$filter', 'ApiService', 'GridStateFactory', 'HelpersService', 'PermissionsService', 'GridDefinitionFactory', 'UserPreferencesService', function($scope, $state, $timeout, $uibModal, $filter, ApiService, GridStateFactory, HelpersService, PermissionsService, GridDefinitionFactory, UserPreferencesService) {

    $scope.posList = {
      queryTimer: false,
      model: [],
      searchQuery: '',
      modalDialog: {},
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      posListGridName: $state.current.name+'.grid0',
      viewId: '',
      pageSize: 50,
      paginationText: '',

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      optionsOverride: {
        enableGridMenu: false,
        rowHeight: 40,
        data: 'posList.model',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.posList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.posList.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function (item) {
            $scope.posList.onGridDblClick(item);
          },
          remove: function (row) {
            $scope.posList.remove(row);
          },
          getAssignedTerminals: function(row) {
            $scope.posList.getAssignedTerminals(row);
          }
        },
        columnDefs: [
          {
            field: 'name',
            displayName: 'Name',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'description',
            displayName: 'Description'
          },
          {
            field: 'pageNumber',
            displayName: 'Number of Pages',
            cellTemplate: '<div class="ui-grid-cell-contents"><span>{{ row.entity.displayItems.length }}</span></div>',
            enableSorting: false
          },
          {
            field: 'currentStatus',
            displayName: 'Status',
            cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-show="row.entity.status.published">Published</span><span data-ng-show="!row.entity.status.published">Draft</span></div>',
            colId: 'published'
          },
          {
            field: 'assigned',
            displayName: 'Assigned',
            onCellNavClick: function(row, col) {
              if (row.entity.assigned) {
                $scope.posList.getAssignedTerminals(row);
              }
            },
            cellTemplate: '<div class="ui-grid-cell-contents">' +
            '<a class="clickable" title="status" id="status" name="status-configuration-row" data-ng-if="row.entity.assigned" data-ng-click="grid.appScope.getAssignedTerminals(row)">Assigned</a>' +
            '<span title="status" data-ng-if="!row.entity.assigned">Unassigned</span>' +
            '</div>'
          }
        ]
      },

      init: function() {

        this.optionsOverride.columnDefs.push(          {
          field: 'status.draftDate',
          displayName: 'Last Updated',
          cellFilter: 'date: "'+ $scope.posList.dateTimeFormat +'"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, $scope.posList.dateTimeFormat);
          },
          colId: 'draftDate'
        });

        if (PermissionsService.check('POS_CONFIG_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.posList.remove(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a class="clickable" title="remove" id="remove" name="remove-configuration-row" data-ng-click="grid.appScope.remove(row)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
            visible: true
          });
        }

        if (PermissionsService.check('POS_CONFIG_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.posList.onGridDblClick(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a class="clickable" title="edit" id="edit" name="edit-configuration-row" data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            visible: true
          });
        }

        $scope.$emit('Application::contentTitleChange', {
          title: 'Point of Sale Configuration',
          buttonRight: {
            label: '+ Create Configuration',
            permissions: 'POS_CONFIG_CREATE',
            action: function() {
              $state.go('application.pos.create.description');
            }
          }
        });

        this.viewId = $state.current.name;

        this.gridDefinition.init(this.posListGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

      },

      initData: function() {
        var self = $scope.posList, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);

        self.getConfigList();
      },

      query: function() {
        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.posList;
          self.gridState.setPropertyValue('search', self.searchQuery);
          $scope.$broadcast('DataGrid::Search', {name: self.posListGridName});
        }, 500);
      },
      
      getConfigList: function() {
        var props = this.gridState.getGridState();

        ApiService.pos.list(props).then(this.success.getConfigList, this.error.configList);
      },

      getAssignedTerminals: function (row) {
        if(row.entity.assigned) {
          var self = $scope.posList,
            configItem = row.entity;
          self.modalDialog = $uibModal.open({
              templateUrl: 'views/application/views/pos/list/modals/statusPosListModal.tpl.html',
              size: 'md',
              controller: 'PosListModalController',
              resolve: {
                configItem : configItem,
                terminals: function () {
                  return ApiService.terminals.config.list(configItem.configId);
                } 
              }
            });
            
          self.modalDialog.result.then(function (res) {
          }, function () {
              // Do nothing
          });
        }
      },
      
      remove: function(row) {
        var listItem = row.entity,
            self = $scope.posList;
        
        console.log('PosListController::removeProgram');
        
        self.modalDialog = $uibModal.open({
          templateUrl: 'views/application/views/pos/modals/posDeleteModal.tpl.html',
          size: 'md',
          controller: 'PosDeleteModalController',
          resolve: {
            listItem : listItem,
            terminals: ApiService.terminals.config.list(listItem.configId),
            allow: !listItem.assigned
          }
        });
        
        // Invoked when modal completes with close(params)
        self.modalDialog.result.then(function() {
          ApiService.pos.remove(listItem.configId).then(function() {
            self.getConfigList();
          });
        }, function() {
          // Do nothing
        });
      },

      success: {
        
        init: function(res) {},
        
        getConfigList: function(response) {
          var self = $scope.posList;
          self.model = response.data.payload.list;
          self.gridDefinition.options.totalItems = response.data.payload.pagination.count;
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length});
          }, 10);
        }
      },

      error: {
        init: function(response) {},
        getConfigList: function(response) {}
      },

      onGridDblClick: function(row) {
        if (PermissionsService.check('POS_CONFIG_UPDATE')) {
          $state.go('application.pos.edit.description', {configId: row.entity.configId});
        }
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.posList;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getConfigList();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.posList, data = columns[0];
        if (data) {
          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.getConfigList();
        }
      }

    };

    $scope.posList.init();

}]);